// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 192 ? "xlsx-style-tw" : chunkId) + "." + {"12":"66ecd379","192":"cdf92da1","453":"b883bf97"}[chunkId] + ".chunk.js";
};